module.exports = __webpack_public_path__ + "img/heat_active.8f61281e.svg";